export default function filterCarriersIfExistsInPostalOperator(
  carrierCodes,
  postalOperators,
) {
  const result = [];
  if (!postalOperators || postalOperators.length === 0) {
    return [...carrierCodes];
  }

  const addIfExists = (carrierCode) => {
    if (carrierCodes.includes(carrierCode)) {
      result.push(carrierCode);
    }
  };

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < postalOperators.length; index++) {
    const postalOperator = postalOperators[index];
    addIfExists(postalOperator.value);
  }

  return result;
}
